import type {
  PlanningListResponse,
  PlanningChartResponse,
  PlanningRatingResponse,
  UpdatePlanningDto,
  PlanningPeriodKey,
  MonthKey,
  MyPlanningSummary,
} from '@crm/shared'
import { apiClient } from './client'

/** Личный план/факт текущего пользователя за текущий месяц. */
export async function getMyPlanning(): Promise<MyPlanningSummary> {
  const res = await apiClient.get<{ success: true; data: MyPlanningSummary }>('/planning/me')
  return res.data.data
}

export interface PlanningQuery {
  period: PlanningPeriodKey
  date?: string // YYYY-MM или YYYY
  from?: string // только для period=custom
  to?: string // только для period=custom
}

export async function getPlanningList(query: PlanningQuery): Promise<PlanningListResponse> {
  const res = await apiClient.get<{ success: true; data: PlanningListResponse }>('/planning', {
    params: query,
  })
  return res.data.data
}

export interface UpdateManagerPlanResult {
  planAmount: number
  factAmount: number
  akbPlanCount: number
  akbFactCount: number
  periodMonth: MonthKey
}

export async function updateManagerPlan(
  managerId: string,
  periodMonth: MonthKey,
  body: UpdatePlanningDto,
): Promise<UpdateManagerPlanResult> {
  const res = await apiClient.patch<{ success: true; data: UpdateManagerPlanResult }>(
    `/planning/${managerId}`,
    body,
    { params: { periodMonth } },
  )
  return res.data.data
}

export async function getPlanningChart(
  query: PlanningQuery & { managerIds: string[] },
): Promise<PlanningChartResponse> {
  const res = await apiClient.get<{ success: true; data: PlanningChartResponse }>(
    '/planning/chart',
    {
      params: {
        ...query,
        managerIds: query.managerIds.length > 0 ? query.managerIds.join(',') : undefined,
      },
    },
  )
  return res.data.data
}

export async function getPlanningRating(
  query: PlanningQuery & { managerIds: string[] },
): Promise<PlanningRatingResponse> {
  const res = await apiClient.get<{ success: true; data: PlanningRatingResponse }>(
    '/planning/rating',
    {
      params: {
        ...query,
        managerIds: query.managerIds.length > 0 ? query.managerIds.join(',') : undefined,
      },
    },
  )
  return res.data.data
}
